function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import useStyle from "./Row.styles";
import { injectTestId } from "@cvent/nucleus-test-automation";
var Row = function(_param) {
    var children = _param.children, _minHeight = _param.minHeight, minHeight = _minHeight === void 0 ? 0 : _minHeight, flexGrow = _param.flexGrow, _justifyContent = _param.justifyContent, justifyContent = _justifyContent === void 0 ? 'flex-start' : _justifyContent, isRtl = _param.isRtl, margin = _param.margin, _className = _param.className, testID = _param.testID, zIndex = _param.zIndex, restProps = _objectWithoutProperties(_param, [
        "children",
        "minHeight",
        "flexGrow",
        "justifyContent",
        "isRtl",
        "margin",
        "className",
        "testID",
        "zIndex"
    ]);
    var styles = useStyle({
        zIndex: zIndex,
        minHeight: minHeight,
        justifyContent: justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.toLowerCase(),
        flexGrow: flexGrow,
        isRtl: isRtl,
        margin: margin
    });
    return _jsx("div", _objectSpread({}, restProps, injectTestId(testID), {
        css: styles,
        "data-layout": "row",
        children: children
    }));
};
export { Row };
export default Row;
